export const text = (state) => {
  return state.notification.text
}

export const type = (state) => {
  return state.notification.type
}

export const hideRefreshLink = (state) => {
  return state.notification.hideRefreshLink
}

export const notificationId = (state) => {
  return state.notification.notificationId
}

export const actionButtons = (state) => {
  return state.notification.actionButtons
}
